module.exports = __webpack_public_path__ + "static/flags/CF-35e9a367864bcf0ec89d7f6643d3df3e.gif";